// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yOZSDVQMK93cehUHRemR{position:absolute;top:0;bottom:auto;left:0;right:auto;z-index:2147483648}.wsT8om70HibSwcxpTrnG{font-size:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optoutStyle": "yOZSDVQMK93cehUHRemR",
	"optoutFontSize": "wsT8om70HibSwcxpTrnG"
};
export default ___CSS_LOADER_EXPORT___;
